import React from 'react';
import { Chip } from '@mui/material';

const CourseCategoryCell = ({ row }) => {
  // 과정 카테고리별 뱃지 색상 구분
  const colorMap = { 
    SOFTWARE_SECURITY: { label: '소프트웨어 개발보안 교육', color: 'success' },
    INFORMATION_SECURITY: { label: '정보보안 교육', color: 'warning' },
    PROGRAMMING: { label: '프로그래밍 교육', color: 'error' },
  };
  
  return (
    <Chip
      label={colorMap[row.courseType]?.label || row.courseType}
      size="small"
      color={colorMap[row.courseType]?.color || 'default'}
      variant="outlined"
    />
  );
};

export default CourseCategoryCell;
